/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */


import React from 'react';
import { IHosportsSiteConfigViewProps } from '../../../modules/hosports-site-config/./hosports-site-config';
//import HolidayTheme from "./../../../baseComponents/holiday-theme/./holiday-theme";

export default (props: IHosportsSiteConfigViewProps) => {
  return (
    <span />
  );
}
